export const P5WrapperClassName = "react-p5-wrapper";
